import { render, staticRenderFns } from "./NcsiNo1_22.vue?vue&type=template&id=da625dd0&scoped=true"
import script from "./NcsiNo1_22.vue?vue&type=script&lang=js"
export * from "./NcsiNo1_22.vue?vue&type=script&lang=js"
import style0 from "./NcsiNo1_22.vue?vue&type=style&index=0&id=da625dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da625dd0",
  null
  
)

export default component.exports